<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-confirm-edit-${this.inoviceId}`"
      :title="$t('common.edit-status')"
      ok-only
      :ok-title="$t('common.edit')"
      @ok="changeInvoiceStatus"
    >
      <b-card-text>
        <h5>{{ $t("common.invoice-sure") }}</h5>
        {{ $t("common.invoice-no-comeback") }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BCardText, BRow, BCol, BFormGroup } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BModal,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    ToastificationContent,
  },
  props: ["inoviceId", "Invoicestatus", "endpoint", "name"],
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
    };
  },

  methods: {
    changeInvoiceStatus() {
      (this.params.form = { status: this.Invoicestatus }),
        (this.params.path = `/${this.endpoint}/${this.inoviceId}/changeStatus`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.$emit("onChange");
            this.$bvModal.hide(`modal-confirm-edit-${this.name}`);
            window.location.reload();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
